import { render, staticRenderFns } from "./PesquisaDemanda.vue?vue&type=template&id=45308d69&"
import script from "./PesquisaDemanda.vue?vue&type=script&lang=js&"
export * from "./PesquisaDemanda.vue?vue&type=script&lang=js&"
import style0 from "./PesquisaDemanda.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports